import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import AddLegalViewTypeIndexCategoriesInteractor from "../interactors/AddLegalViewTypeIndexCategoriesInteractor";
import AddLegalViewTypeVisibilityLevelsInteractor from "../interactors/AddLegalViewTypeVisibilityLevelsInteractor";
import AddOrganisationLegalViewTypesInteractor from "../interactors/AddOrganisationLegalViewTypesInteractor";
import GetAllOrganisationLegalViewTypesWithCategoriesInteractor from "../interactors/GetAllOrganisationLegalViewTypesWithCategoriesInteractor";
import GetLegalViewTypeIndexCategoriesInteractor from "../interactors/GetLegalViewTypeIndexCategoriesInteractor";
import GetLegalViewTypesVisibilityLevelsInteractor from "../interactors/GetLegalViewTypesVisibilityLevelsInteractor";
import GetOrganisationLegalViewTypesInteractor from "../interactors/GetOrganisationLegalViewTypesInteractor";
import RemoveDocumentLegalViewTypeInteractor from "../interactors/RemoveDocumentLegalViewTypeInteractor";
import ShowOrganisationLegalViewTypesInteractor from "../interactors/ShowOrganisationLegalViewTypesInteractor";
import OrganisationLegalViewTypesPage from "../ui/pages/OrganisationLegalViewTypesPage";

export default class OrganisationLegalViewTypesArea
  extends Area
  implements IArea
{
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }
  private registerModules() {
    const container = this.application.container;
    container.registerInteractor(
      "addOrganisationLegalViewTypes",
      AddOrganisationLegalViewTypesInteractor
    );
    container.registerInteractor(
      "getOrganisationLegalViewTypes",
      GetOrganisationLegalViewTypesInteractor
    );
    container.registerInteractor(
      "showOrganisationLegalViewTypes",
      ShowOrganisationLegalViewTypesInteractor
    );
    container.registerInteractor(
      "addLegalViewTypeIndexCategories",
      AddLegalViewTypeIndexCategoriesInteractor
    );
    container.registerInteractor(
      "getLegalViewTypeIndexCategories",
      GetLegalViewTypeIndexCategoriesInteractor
    );
    container.registerInteractor(
      "getAllOrganisationLegalViewTypesWithCategories",
      GetAllOrganisationLegalViewTypesWithCategoriesInteractor
    );
    container.registerInteractor(
      "addLegalViewTypeVisibilityLevels",
      AddLegalViewTypeVisibilityLevelsInteractor
    );
    container.registerInteractor(
      "getLegalViewTypesVisibilityLevels",
      GetLegalViewTypesVisibilityLevelsInteractor
    );
    container.registerInteractor(
      "removeDocumentLegalViewType",
      RemoveDocumentLegalViewTypeInteractor
    );
  }
  register(params: any) {
    this.registerModules();
    this.router.registerRoutes({
      path: "/organisations/:id/legal-view-type",
      page: this.createPage({
        Page: OrganisationLegalViewTypesPage,
        action: this.showOrganisationLegalViewTypesPage.bind(this)
      }),
      options: {
        secure: true
      }
    });
  }

  public showOrganisationLegalViewTypesPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowOrganisationLegalViewTypesInteractor>(
        "showOrganisationLegalViewTypes"
      )
      .execute(Number.parseInt(id, 10));
  }
}
